/*
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-09-24 10:34:32
 * @LastEditors: FJW
 * @LastEditTime: 2025-04-10 17:37:22
 */
import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
import Vue from 'vue'
import BASE_API from '/env.js'

const http = axios.create({
	baseURL: BASE_API.VUE_APP_SHOP_BASE_API,
	timeout: 1000 * 30,
	withCredentials: true,
	headers: {
		'Content-Type': 'application/json; charset=utf-8'
	}
})
const _vm = new Vue()

/**
 * 请求拦截
*/
http.interceptors.request.use(config => {
	let accessToken = sessionStorage.getItem("accessTokenKm");
	if (accessToken) {
		config.headers.accessToken = encodeURIComponent(accessToken);
		config.headers.Authorization = 'Bearer ' + accessToken // 让每个请求携带自定义token
	}
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(async response => {
	_vm.$isLoading.close()
	if (response.data.code == 0) {
		return response.data
	} else {
		Message({
			message: response.data.msg,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
		return Promise.reject(response.data)
	}
}, error => {
	_vm.$isLoading.close()
	if (error.response && error.response.status) {

		switch (error.response.code) {
			case 400:
				Message({
					message: error.response.data,
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 401:
				router.replace("/login");
				break
			case 405:
				Message({
					message: 'http请求方式有误',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 404:
			case 500:
				Message({
					message: '服务器出了点小差，请稍后再试',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
			case 501:
				Message({
					message: '服务器不支持当前请求所需要的某个功能',
					type: 'error',
					duration: 1500,
					customClass: 'element-error-message-zindex'
				})
				break
		}
	} else {
		Message({
			message: error,
			type: 'error',
			duration: 1500,
			customClass: 'element-error-message-zindex'
		})
	}


	return Promise.reject(error)
})


export default http
